export default class TransactionModel {
  constructor(debit) {
    this.id = 0;
    this.debit = debit || 0;
    this.designation = "";
    this.amount = 0;
    this.credit = 0;
    this.date = new Date();
    this.IsCancelled = false;
    this.representative = "";
    this.clientId = null;
    this.checkoutId = null;
    this.bankId = null;
    this.ref = "";
    this.attachments = "";
    this.dueDate = new Date();
    this.disponibilityId = null;
    this.infosB2C = null;
    this.paiment = 0;
    this.refCheck = "";
    this.users = [];
    this.refund = false;
    this.transactionRefund = null;
    this.paidFor = [];
    this.isClientB2C = false;
    this.referrerId = null;
    this.TotalPrice = 0;
  }
}

export class PaidForModel {
  constructor() {
    this.clientId = 0;
    this.fullName = "";
    this.passportNumber = "";
    this.phone = "";
    this.email = "";
    this.checkoutId = null;
  }
}
